import routesData from '@/src/routesData.local.json';
import { Metadata } from 'next';
import getOption from './getOption';

export function getPageData(slug: string) {
  const page = routesData[slug as keyof typeof routesData];
  if (page) {
    return { ...page, slug };
  }
  return false;
}

export function getPageMetaData(
  slug: string,
  locale: string,
  searchParams: { [key: string]: string } = {}
): Metadata {
  const page = getPageData(slug) as any;
  const ats = process.env.NEXT_PUBLIC_TITLE ?? 'ATS';
  const isPaginated = searchParams?.page && searchParams.page !== '1';
  const baseUrl = process.env.NEXT_PUBLIC_URL || '';
  const localePrefix = `/${locale}/`;
  // Set canonical URL, removing /category/ prefix
  const translatedSlug = page?.[`slug-${locale}`] || slug;
  const canonicalUrl = `${baseUrl}${localePrefix}${translatedSlug}`.replace(
    /([^:]\/)\/+/g,
    '$1'
  );

  const meta = {
    title: ats,
    openGraph: {
      images: [getOption('URL') + '/ats.png'],
    },
    robots: {
      // Set noindex only for original category routes and paginated pages
      index: isPaginated ? false : true,
      follow: isPaginated ? false : true,
      googleBot: {
        index: isPaginated ? false : true,
        follow: isPaginated ? false : true,
      },
    },
    alternates: {
      canonical: isPaginated ? canonicalUrl : '',
      languages: {
        [locale]: baseUrl + '/' + locale,
      },
    },
  } as Metadata;
  if (page) {
    meta.title =
      (page['meta-title-' + locale] ||
        page['title-' + locale] ||
        page['name-' + locale] ||
        slug) +
      ' - ' +
      ats;
    const description =
      page['meta-description-' + locale] || page['description-' + locale];
    if (description) {
      meta.description = description;
    }
  }
  return meta;
}
